export const caseKeyMap = {
  isFirstCase: [
    "netPay",
    "tax",
    "earnedBasic",
    "earnedPeraAda",
    "deductionsSet",
  ],
  isSecondCase: [
    "netPay",
    "deductionsSet",
    "tax",
    "earnedBasic",
    "earnedPeraAda",
  ],
  isThirdCase: [
    "netPay",
    "tax",
    "deductionsSet",
    "earnedBasic",
    "earnedPeraAda",
    "basicRateForBackPay",
    "peraAdaForBackPay",
    "deductionPeraAda",
    "overpaymentBasic",
    "overpaymentPeraAda",
    "deductionsDueToLeavesAbsencesAndTardinessBasic",
  ],
  isFourthCase: ["deductionsSet", "netAmount", "tax", "netEarned"],
  isFifthCase: [
    "earnedForThePeriod",
    "deductionsSet",
    "3",
    "2",
    "5",
    "10",
    "totalTax",
    "netPay",
  ],

  isSixthCase: [
    "netPay",
    "earnedForThePeriod",
    "3",
    "2",
    "5",
    "10",
    "totalTax",
  ],
  isSeventhCase: [
    "netPay",
    "basicEarned",
    "peraAdaEarned",
    "total",
    "tax",
    "deductionsSet",
  ],
  isEightCase: ["netPay", "earnedForThePeriod", "tax", "deductionsSet"],
  isNinthCase: [
    "representationAllowanceTransportationAllowanceRata",
    "netAmount",
  ],
  isTenthCase: ["tax", "myDiff", "yeDiff", "netPay" ],
  isEleventhCase: [
    "basicSalary",
    "proratedRate",
    "absMins",
    "earned",
    "20",
    "totalEarned",
    "tax3",
    "netAmount",
  ],
  isTwelvethCase: [
    "proratedApRate",
    "absencesLeaves",
    "latesUtPerMinute3",
    "earnedCurrentAssignment",
    "airportAugmentationRate",
    "amountEarnedAirportAugmentation",
    "absencesLeaves2",
    "latesUtPerMinute4",
    "earnedAirportDuties",
    "netEarned",
    "totalEarned",
    "netAmount",
    "tax",
    "deductionsSet"
  ],
  isTirteenthCase: ["deductionsSet", "netPay"],
  isFourteenthCase: [
    "earnedForThePeriod",
    "earnedForThePeriod2",
    "totalEarned",
    "20EarnedAmount",
    "3",
    "netPay",
  ],
};
